/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_App_TitleInputs */

const en_portal_rail_app_title = /** @type {(inputs: Portal_Rail_App_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone and Android`)
};

const pl_portal_rail_app_title = /** @type {(inputs: Portal_Rail_App_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone i Android`)
};

/**
* | output |
* | --- |
* | "iPhone and Android" |
*
* @param {Portal_Rail_App_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_app_title = /** @type {((inputs?: Portal_Rail_App_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_App_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_app_title(inputs)
	return en_portal_rail_app_title(inputs)
});